module.exports = __webpack_public_path__ + "static/media/overpass-extrabold-italic.1120bb04.ttf";